import { CircularProgress, makeStyles, Typography } from '@material-ui/core';
import { Trans } from '@lingui/macro';

const useLoadIndicatorStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionRow,
        ...theme.mixins.flex.alignItemsCenter,

        width: '100%',

        padding: theme.spacing(2, 1),
        cursor: 'default',

        '& > *:last-child': {
            paddingLeft: theme.spacing(1),
        },
    },
}));

export default function RowLoadIndicator() {
    const classes = useLoadIndicatorStyles();

    return (
        <div className={classes.root}>
            <CircularProgress size={16} />
            <Typography variant="subtitle2">
                <Trans>Loading...</Trans>
            </Typography>
        </div>
    );
}
